import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "desTitle"
};
const _hoisted_2 = {
  class: "erWeiMaCode",
  ref: "erWeiMaCode"
};
const _hoisted_3 = {
  key: 2,
  class: "h5Img"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "otherDatas"
};
const _hoisted_6 = {
  class: "swiper-container",
  ref: "swipercontainer"
};
const _hoisted_7 = {
  class: "swiper-wrapper"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "nav_list",
  id: "nav_list"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 4,
  class: "descContent"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  key: 5,
  id: "voice",
  ref: "voice",
  preload: "auto"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  key: 6,
  class: "videoDetail",
  id: "videoItem",
  controls: "",
  loop: "",
  muted: "",
  ref: "videoPlayer"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = {
  key: 7,
  id: "c1",
  width: "380",
  height: "600"
};
const _hoisted_19 = {
  key: 8,
  id: "c2",
  width: "380",
  height: "600"
};
const _hoisted_20 = {
  key: 9,
  id: "c3",
  width: "380",
  height: "600"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_lsDetailScript = _resolveComponent("lsDetailScript");
  const _component_lsDetail = _resolveComponent("lsDetail");
  const _component_mobile = _resolveComponent("mobile");
  const _component_bigImg = _resolveComponent("bigImg");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`new3DDetail ${$data.isMobile ? 'h5' : ''} ${_ctx.$route.query.type || 'white'}`)
  }, [!_ctx.$route.query.hideOthers ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "back",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toIndex && $options.toIndex(...args))
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [$data.columns.length > 1 ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: _normalizeClass(`column_${$data.columns.findIndex(c => {
      return c.columnName == $data.detail.columnName;
    })}`)
  }, _toDisplayString($data.detail.columnName), 3)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString($data.detail.name), 1)]), !$data.isMobile ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "code",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.clickErCode && $options.clickErCode(...args))
  }, [!$data.showBigErCode ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(`erWeiMa ${$data.showBigErCode ? '' : 'activeSmallEr'}`)
  }, null, 2)) : _createCommentVNode("", true), $data.showBigErCode ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(`erWeiMaBig ${!$data.showBigErCode ? 'hideEr' : 'activeEr'}`)
  }, [_createElementVNode("div", _hoisted_2, null, 512), _cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "erWeiMaName"
  }, [_createTextVNode("扫一扫"), _createElementVNode("br"), _createTextVNode("3D文物带回家")], -1))], 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.showModels[0] && $data.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
    src: $data.detail.img
  }, null, 8, _hoisted_4)])) : _createCommentVNode("", true), _createVNode(_component_lsDetailScript), $data.showDetail ? (_openBlock(), _createBlock(_component_lsDetail, {
    key: 3,
    detailCode: $data.detailCode,
    showModels: $data.showModels,
    isMobile: $data.isMobile,
    ref: "lsDetail",
    activeIndex: $data.activeIndex,
    onSetParent: $options.setParent
  }, null, 8, ["detailCode", "showModels", "isMobile", "activeIndex", "onSetParent"])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_5, [_cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "btnTurnLeft"
  }, null, -1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(`swiper-slide ${item.code == this.detailCode && item.type == this.detail.type ? 'activeDetail' : ''}`),
      onClick: $event => $options.clickDetail(index, item.m_index)
    }, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_9)], 10, _hoisted_8);
  }), 256))])], 512), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "btnTurnRight"
  }, null, -1))], 512), [[_vShow, !$data.isMobile && !_ctx.$route.query.hideOthers]]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
    class: _normalizeClass(`nav_item icon_1 ${$data.showModels[0] ? 'active' : ''}`),
    onClick: _cache[2] || (_cache[2] = $event => $options.showModel(0))
  }, _cache[9] || (_cache[9] = [_createElementVNode("i", null, null, -1), _createElementVNode("span", null, null, -1)]), 2), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(`nav_item icon_2 ${$data.showModels[1] ? 'active' : ''}`),
    onClick: _cache[3] || (_cache[3] = $event => $options.showModel(1))
  }, _cache[10] || (_cache[10] = [_createElementVNode("i", null, null, -1), _createElementVNode("span", null, null, -1)]), 2), [[_vShow, $data.detail.zhuanti]]), $data.detail.audio ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(`nav_item ${$data.showModels[2] ? 'icon_3_a' : 'icon_3'}`),
    id: "radio",
    onClick: _cache[4] || (_cache[4] = $event => $options.showModel(2))
  }, [_cache[11] || (_cache[11] = _createElementVNode("i", null, null, -1)), $data.showModels[2] ? (_openBlock(), _createElementBlock("span", _hoisted_11, "语音介绍")) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)]), $data.showModels[0] ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", {
    class: "description",
    innerHTML: $data.detail.description
  }, null, 8, _hoisted_13), _createElementVNode("div", {
    class: "closeDesc",
    onClick: _cache[5] || (_cache[5] = $event => $options.showModel(0))
  })])) : _createCommentVNode("", true), $data.detail.audio && !$data.detail.videoUrl ? (_openBlock(), _createElementBlock("audio", _hoisted_14, [_createElementVNode("source", {
    src: $data.detail.audio,
    type: "audio/mpeg"
  }, null, 8, _hoisted_15)], 512)) : _createCommentVNode("", true), $data.detail.videoUrl ? (_openBlock(), _createElementBlock("video", _hoisted_16, [_createElementVNode("source", {
    src: $data.detail.videoUrl
  }, null, 8, _hoisted_17)], 512)) : _createCommentVNode("", true), $data.showVideo ? (_openBlock(), _createElementBlock("canvas", _hoisted_18)) : _createCommentVNode("", true), $data.showVideo ? (_openBlock(), _createElementBlock("canvas", _hoisted_19)) : _createCommentVNode("", true), $data.showVideo ? (_openBlock(), _createElementBlock("canvas", _hoisted_20)) : _createCommentVNode("", true), _createVNode(_component_mobile), $data.isMobile && $data.showBigImg ? (_openBlock(), _createBlock(_component_bigImg, {
    key: 10,
    imgs: $data.detail.images
  }, null, 8, ["imgs"])) : _createCommentVNode("", true)], 2);
}